import { runCalcWithAutoFundingFix } from './runCalcWithAutoFundingFix';
import {
  SCENARIO_ADJUSTMENT_MODE,
  isNoopScenarioAdjustment,
} from './applyRoasScenarioAdjustment';
import { OPTIONAL_SCENARIO_KEYS, SCENARIO_META } from './scenarioMeta';

/** Resolve a UI scenario config into a runCalc adjustment, or null when off/no-op. */
export function resolveScenarioAdjustment(config, direction) {
  if (!config || !config.enabled) {
    return null;
  }
  const value = Math.max(0, Number(config.value) || 0);
  const mode =
    config.mode === SCENARIO_ADJUSTMENT_MODE.ABSOLUTE
      ? SCENARIO_ADJUSTMENT_MODE.ABSOLUTE
      : SCENARIO_ADJUSTMENT_MODE.PERCENT;
  const adjustment = { mode, value, direction };
  return isNoopScenarioAdjustment(adjustment) ? null : adjustment;
}

/**
 * Run the base case plus any enabled bull / bear scenarios. Each scenario reuses
 * the full calc (including auto funding fix); only the cumulative ROAS vector is
 * shifted via `roasScenarioAdjustment`. Does not mutate the input state.
 *
 * @returns {{ results: {base, bull, bear}, autoFix }} where each results value is
 *   a calcResult object (bull / bear are null when disabled) and autoFix is the
 *   base-case auto-fix metadata.
 */
export function runScenarios(
  state,
  exposureGradeLimits,
  planMonths = [],
  scenarioSettings = {}
) {
  const base = runCalcWithAutoFundingFix(
    state,
    exposureGradeLimits,
    planMonths
  );
  const results = { base: base.calcResult, bull: null, bear: null };

  OPTIONAL_SCENARIO_KEYS.forEach((key) => {
    const adjustment = resolveScenarioAdjustment(
      scenarioSettings[key],
      SCENARIO_META[key].direction
    );
    if (!adjustment) {
      return;
    }
    const scenarioState = { ...state, roasScenarioAdjustment: adjustment };
    results[key] = runCalcWithAutoFundingFix(
      scenarioState,
      exposureGradeLimits,
      planMonths
    ).calcResult;
  });

  return { results, autoFix: base.autoFix };
}
